import { type OpenedContract, toNano } from '@ton/core'
import type { BoxV0 } from '@voteboxio/core'
import { useAppContext } from '../contexts/App.context'
import { getMockBlockchainResult, isE2ETestMode } from '../utils/testMode'

import { generateQueryId } from '../utils/common'

export const useVote = (
  openedContact: OpenedContract<BoxV0.BoxV0> | undefined,
  recommendedVoteGas: string,
) => {
  const { sender } = useAppContext()

  const sendVote = async (
    index: number,
    amount: string,
  ): Promise<{ isSuccess: boolean; error?: string }> => {
    // In E2E test mode, return mock result instead of real blockchain call
    if (isE2ETestMode()) {
      const mockResult = getMockBlockchainResult()
      if (mockResult) {
        // Simulate network delay
        await new Promise(resolve => setTimeout(resolve, 500))
        return mockResult
      }
    }

    if (!openedContact || !amount) {
      console.error('Failed to send user vote')
      return { isSuccess: false, error: 'Missing contract or amount' }
    }

    try {
      if (!sender) {
        throw new Error('Use vote without sender')
      }

      const userTonStake = toNano(amount)

      const result = await openedContact.send(
        sender,

        { value: BigInt(userTonStake) + BigInt(recommendedVoteGas) },

        {
          $$type: 'Vote',
          choice: BigInt(index),
          ton_stake: BigInt(userTonStake),
          query_id: generateQueryId(),
        },
      )
      console.log(result)
      return { isSuccess: true }
    } catch (error) {
      console.error('Error sending user vote', error)
      return {
        isSuccess: false,
        error: error instanceof Error ? error.message : 'Transaction failed',
      }
    }
  }

  const isValidVotingAmount = (amount: string) => {
    if (Number(amount) > 0) {
      return true
    }

    return false
  }

  return {
    sendVote,
    isValidVotingAmount,
  }
}
